import { Box, Container } from '@mui/material';
import PageHeader from 'components/common/PageHeader/PageHeader';
import ContentReportsTable from 'components/tables/ContentReportsTable/ContentReportsTable';
import useGlobalStyles from 'styles/globalStyles';

// Mistakes shoppers reported in what the app wrote about products and ingredients.
export default function ContentReportsPage() {
  const globalStyles = useGlobalStyles();

  return (
    <Box className={globalStyles.container}>
      <Container
        maxWidth={'xl'}
        className={globalStyles.container}
      >
        <Box pt={2}>
          <PageHeader title={'Content Reports'} />
        </Box>

        <Box mt={3}>
          <ContentReportsTable />
        </Box>
      </Container>
    </Box>
  )
}
